const testIds = {
  num_of_rooms: 'num_of_rooms',
  services: 'services',
  parking: 'parking',
  pick_up_service: 'pick_up_service',
  laundry: 'laundry',
  facilities_amenities: 'facilities_amenities',
  comfort_security: 'comfort_security',
  wifi: 'wifi',
  smoking: 'smoking',
  meal: 'meal',
  onsen: 'onsen',
  facility_other: 'facility_other',
  bathroom: 'bathroom',
  entertainment: 'entertainment',
  electric: 'electric',
  room_other: 'room_other',
  room_wear: 'room_wear',
  listitem_title: 'listitem_title',
  listitem_description: 'listitem_description',
  entertainment_connectivity: 'entertainment_connectivity',
  accessibility: 'accessibility',
};

export default testIds;
